import script from "./switch-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./switch-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./switch-setting-ly.vue?vue&type=style&index=0&id=ab692da2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab692da2"]])

export default __exports__